(function () {
  'use strict';

  if (window.UnifiedConsent) {
    return;
  }

  const VERSION = '1.0.0';

  function analyticsAllowed() {
    const config = window.UnifiedTrackingConfig || {};

    if (config.consentRequired !== true) {
      return true;
    }

    try {
      return Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true
      );
    } catch (error) {
      return false;
    }
  }

  function getStatus() {
    return {
      required: (window.UnifiedTrackingConfig || {}).consentRequired === true,
      analytics_allowed: analyticsAllowed()
    };
  }

  window.UnifiedConsent = {
    version: VERSION,
    analyticsAllowed: analyticsAllowed,
    getStatus: getStatus
  };
})();
